/* ===========================================================================
   OESFX — chrome, pointer and motion.

   Two rules govern this file.

   1. Nothing is ever hidden by the stylesheet. Every start state for a reveal
      is written here with gsap.set, and only after GSAP is confirmed present.
      If this script fails, or GSAP is blocked, the page still reads.

   2. Reveals are triggered by IntersectionObserver, not by scroll position.
      A scroll library, a restored scroll position or a programmatic jump can
      all leave a scroll-position trigger unfired; an observer still fires.
      On top of that a watchdog sweeps for anything that should have been
      revealed by now and simply shows it.
   =========================================================================== */
(function () {
  if (window.__oxInit) return;
  window.__oxInit = true;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fine = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var hasGsap = typeof window.gsap !== 'undefined' && typeof window.ScrollTrigger !== 'undefined';
  var roots = [].slice.call(document.querySelectorAll('.ox'));
  var hidden = [];
  var E = 'expo.out';

  var track = function (el) { if (hidden.indexOf(el) < 0) hidden.push(el); return el; };
  var untrack = function (els) {
    [].concat(els).forEach(function (el) {
      var i = hidden.indexOf(el);
      if (i > -1) hidden.splice(i, 1);
    });
  };

  /* =========================================================================
     HEADER
     ========================================================================= */
  (function header() {
    var h = document.getElementById('oxh');
    if (!h) return;
    var menu = document.getElementById('oxm');
    var bg = document.getElementById('oxbg');

    var first = document.querySelector('main .shopify-section .ox');
    if (first && first.classList.contains('pp')) h.classList.add('lt');

    var last = 0, ticking = false;
    var onScroll = function () {
      var y = window.pageYOffset || document.documentElement.scrollTop;
      h.classList.toggle('on', y > 60);
      if (!document.body.classList.contains('oxmenu')) {
        h.classList.toggle('hid', y > 420 && y > last + 4);
      }
      last = y;
      ticking = false;
    };
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; window.requestAnimationFrame(onScroll); }
    }, { passive: true });
    onScroll();

    if (bg && menu) {
      var links = [].slice.call(menu.querySelectorAll('a.ml'));
      links.forEach(function (a, i) { a.style.transitionDelay = (0.06 + i * 0.045).toFixed(3) + 's'; });
      var setOpen = function (open) {
        document.body.classList.toggle('oxmenu', open);
        bg.setAttribute('aria-expanded', open ? 'true' : 'false');
        bg.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
        if (open) h.classList.remove('hid');
        if (window.__oxLenis) { if (open) { window.__oxLenis.stop(); } else { window.__oxLenis.start(); } }
      };
      bg.addEventListener('click', function () { setOpen(!document.body.classList.contains('oxmenu')); });
      menu.addEventListener('click', function (e) { if (e.target.closest('a')) setOpen(false); });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && document.body.classList.contains('oxmenu')) { setOpen(false); bg.focus(); }
      });
      var wide = window.matchMedia('(min-width: 901px)');
      if (wide.addEventListener) wide.addEventListener('change', function (m) { if (m.matches) setOpen(false); });
    }
  })();

  /* =========================================================================
     POINTER
     ========================================================================= */
  if (fine && !reduce) {
    var cur = document.createElement('div');
    cur.className = 'oxcur';
    cur.innerHTML = '<span class="oxcur-t"></span><svg viewBox="0 0 14 14" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M1 7h11M8 2.5L12.5 7 8 11.5"/></svg>';
    document.body.appendChild(cur);
    var curT = cur.querySelector('.oxcur-t');
    var tX = -200, tY = -200, cX = -200, cY = -200, frame = 0, live = false, held = null;

    var draw = function () {
      cX += (tX - cX) * 0.22; cY += (tY - cY) * 0.22;
      cur.style.transform = 'translate3d(' + cX.toFixed(1) + 'px,' + cY.toFixed(1) + 'px,0) translate(-50%,-50%)';
      if (live || Math.abs(tX - cX) > 0.3 || Math.abs(tY - cY) > 0.3) frame = requestAnimationFrame(draw);
      else frame = 0;
    };
    var kickFrame = function () { if (!frame) frame = requestAnimationFrame(draw); };

    var labelFor = function (el) {
      if (!el || !el.closest) return null;
      var d = el.closest('[data-cur]');
      if (d) return d.getAttribute('data-cur') || '';
      var tile = el.closest('.ox .tile');
      if (tile) return tile.classList.contains('img') ? 'See the work' : 'View case study';
      if (el.closest('.ox a.stkp')) return 'Open';
      if (el.closest('.ox .logos a.lg')) return 'Visit';
      return null;
    };
    var onPale = function (host) {
      if (!host) return false;
      var c = host.classList;
      if (c.contains('tile') && !c.contains('port') && !c.contains('txt') && host.querySelector('img')) return false;
      if (c.contains('t3') || c.contains('k2') || c.contains('k4') || c.contains('txt')) return false;
      if (c.contains('t2') || c.contains('k0') || c.contains('k1') || c.contains('k3')) return true;
      return !!host.closest('.pp');
    };
    var show = function (text, dark) {
      curT.textContent = text;
      cur.classList.toggle('ink', !!dark);
      if (!live) { live = true; cur.classList.add('on'); kickFrame(); }
    };
    var hidePill = function () {
      if (!live) return;
      live = false; cur.classList.remove('on');
      if (held) { held.classList.remove('oxcur-hide'); held = null; }
    };
    document.addEventListener('mousemove', function (e) {
      tX = e.clientX; tY = e.clientY;
      var lab = labelFor(e.target);
      if (lab === null) { hidePill(); kickFrame(); return; }
      var host = e.target.closest('[data-cur],.ox .tile,.ox a.stkp,.ox .logos a.lg');
      if (host !== held) {
        if (held) held.classList.remove('oxcur-hide');
        held = host;
        if (held) held.classList.add('oxcur-hide');
      }
      show(lab, onPale(host));
      kickFrame();
    }, { passive: true });
    document.addEventListener('mousedown', function () { cur.classList.add('down'); }, { passive: true });
    document.addEventListener('mouseup', function () { cur.classList.remove('down'); }, { passive: true });
    document.addEventListener('mouseleave', hidePill);
    window.addEventListener('blur', hidePill);
    window.addEventListener('scroll', function () { if (live) kickFrame(); }, { passive: true });

    document.querySelectorAll('.ox .btn, .oxh .q').forEach(function (b) {
      b.classList.add('mag');
      var r = null;
      b.addEventListener('mouseenter', function () { r = b.getBoundingClientRect(); });
      b.addEventListener('mousemove', function (e) {
        if (!r) r = b.getBoundingClientRect();
        var dx = (e.clientX - (r.left + r.width / 2)) * 0.2;
        var dy = (e.clientY - (r.top + r.height / 2)) * 0.26;
        b.style.transform = 'translate3d(' + dx.toFixed(1) + 'px,' + dy.toFixed(1) + 'px,0)';
      }, { passive: true });
      b.addEventListener('mouseleave', function () {
        r = null;
        b.style.transition = 'transform .55s cubic-bezier(.16,1,.3,1)';
        b.style.transform = '';
        window.setTimeout(function () { b.style.transition = ''; }, 580);
      });
    });
  }

  /* =========================================================================
     HERO VIDEO
     ========================================================================= */
  (function heroVideo() {
    var hv = document.querySelector('.ox .hero video');
    if (!hv) return;
    if (window.matchMedia('(max-width: 700px) and (orientation: portrait)').matches && hv.dataset.m) {
      hv.pause();
      hv.querySelectorAll('source').forEach(function (s) { s.remove(); });
      hv.dataset.m.split('|').filter(Boolean).forEach(function (u) {
        var s = document.createElement('source'); s.src = u; s.type = 'video/mp4'; hv.appendChild(s);
      });
      if (hv.dataset.mp) hv.poster = hv.dataset.mp;
      hv.load();
    }
    var kick = function () { if (hv.paused) { var p = hv.play(); if (p && p.catch) p.catch(function () {}); } };
    document.addEventListener('visibilitychange', function () { if (!document.hidden) kick(); });
    ['touchstart', 'scroll', 'pointerdown'].forEach(function (ev) { window.addEventListener(ev, kick, { once: true, passive: true }); });
    window.addEventListener('load', kick);
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) kick(); else if (!hv.paused) hv.pause(); });
      }, { rootMargin: '250px' }).observe(hv);
    }
  })();

  /* =========================================================================
     FORM
     ========================================================================= */
  (function form() {
    var f = document.getElementById('oxform');
    if (!f) return;
    var msg = document.getElementById('oxmsg'), btn = document.getElementById('oxsend');
    var check = function (el) {
      var wrap = el.closest('.fl'), ok = true;
      if (el.required && !el.value.trim()) ok = false;
      if (ok && el.type === 'email' && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(el.value.trim())) ok = false;
      if (wrap) wrap.classList.toggle('err', !ok);
      return ok;
    };
    f.querySelectorAll('[required]').forEach(function (el) {
      el.addEventListener('input', function () { check(el); });
      el.addEventListener('blur', function () { check(el); });
    });
    f.addEventListener('submit', function (e) {
      var all = true;
      f.querySelectorAll('[required]').forEach(function (el) { if (!check(el)) all = false; });
      if (!all) {
        e.preventDefault();
        if (msg) msg.classList.add('on');
        var firstBad = f.querySelector('.fl.err input,.fl.err select,.fl.err textarea');
        if (firstBad) firstBad.focus();
        return;
      }
      if (msg) msg.classList.remove('on');
      if (window.oxTrack) window.oxTrack('enquiry_submit', {});
      if (btn) { btn.disabled = true; var sp = btn.querySelector('span'); if (sp) sp.textContent = 'Sending…'; }
    });
  })();

  /* =========================================================================
     STATEMENT — wrap words so single words can be picked out in green.
     ========================================================================= */
  roots.forEach(function (root) {
    root.querySelectorAll('.stmt').forEach(function (stmt) {
      if (stmt.dataset.split) return;
      var hi = (stmt.dataset.hi || '').split('|').map(function (s) { return s.trim().toLowerCase(); }).filter(Boolean);
      var words = stmt.textContent.trim().split(/\s+/);
      stmt.innerHTML = words.map(function (w) {
        var clean = w.replace(/[^\w']/g, '').toLowerCase();
        return '<span class="wd' + (hi.indexOf(clean) > -1 ? ' hi' : '') + ' on">' + w + '</span>';
      }).join(' ');
      stmt.dataset.split = '1';
    });
  });

  /* =========================================================================
     WATCHDOG — anything that should be on screen by now, and is not, is shown.
     ========================================================================= */
  var sweep = function () {
    var vh = window.innerHeight || 800;
    for (var i = hidden.length - 1; i >= 0; i--) {
      var el = hidden[i];
      if (!el || !el.isConnected) { hidden.splice(i, 1); continue; }
      var r = el.getBoundingClientRect();
      if (r.top > vh * 1.25) continue;            /* not due yet */
      var cs = getComputedStyle(el);
      var m = (cs.transform || '').indexOf('matrix') === 0 ? parseFloat(cs.transform.split(',')[5] || 0) : 0;
      var stuck = parseFloat(cs.opacity) < 0.08
        || (cs.clipPath || '').indexOf('100%') > -1
        || Math.abs(m) > Math.max(18, r.height * 0.45);
      if (stuck) {
        el.style.opacity = '';
        el.style.transform = 'none';
        el.style.clipPath = 'none';
        el.__oxr = null;
        hidden.splice(i, 1);
      }
    }
  };
  window.addEventListener('load', function () { window.setTimeout(sweep, 1700); });
  [3200, 7000, 14000].forEach(function (d) { window.setTimeout(sweep, d); });
  var swt = 0;
  window.addEventListener('scroll', function () {
    if (swt || !hidden.length) return;
    swt = window.setTimeout(function () { swt = 0; sweep(); }, 900);
  }, { passive: true });

  if (!hasGsap) return;   /* nothing was hidden, so there is nothing to undo */

  gsap.registerPlugin(ScrollTrigger);

  /* =========================================================================
     SMOOTH SCROLL — Lenis on the GSAP ticker.
     ========================================================================= */
  if (!reduce && typeof window.Lenis === 'function' && fine) {
    var lenis = new Lenis({ lerp: 0.09, wheelMultiplier: 1, smoothWheel: true, syncTouch: false });
    window.__oxLenis = lenis;
    lenis.on('scroll', ScrollTrigger.update);
    gsap.ticker.add(function (t) { lenis.raf(t * 1000); });
    gsap.ticker.lagSmoothing(0);
    document.addEventListener('click', function (e) {
      var a = e.target.closest('a[href^="#"]');
      if (!a) return;
      var id = a.getAttribute('href');
      if (id.length < 2) return;
      var to = document.querySelector(id);
      if (!to) return;
      e.preventDefault();
      lenis.scrollTo(to, { offset: -90, duration: 1.15 });
    });
  }

  /* =========================================================================
     REVEALS — observer driven
     ========================================================================= */
  var io = ('IntersectionObserver' in window) ? new IntersectionObserver(function (es) {
    es.forEach(function (e) {
      if (!e.isIntersecting) return;
      io.unobserve(e.target);
      var f = e.target.__oxr;
      if (f) { e.target.__oxr = null; f(); }
    });
  }, { rootMargin: '0px 0px -6% 0px', threshold: 0.02 }) : null;

  var onView = function (el, fn) {
    if (!io) { fn(); return; }
    el.__oxr = fn;
    io.observe(el);
  };

  var splittable = function (el) {
    if (el.dataset.oxln) return false;
    if (el.closest('.hero')) return false;
    for (var i = 0; i < el.children.length; i++) {
      if (!/^(EM|I|B|STRONG|SPAN|BR)$/.test(el.children[i].tagName)) return false;
    }
    var t = el.textContent.trim();
    return t.length > 0 && t.length < 260;
  };

  var splitToLines = function (el) {
    var words = [];
    (function walk(n) {
      [].slice.call(n.childNodes).forEach(function (c) {
        if (c.nodeType === 3) {
          var parts = c.textContent.split(/(\s+)/), frag = document.createDocumentFragment();
          parts.forEach(function (p) {
            if (!p) return;
            if (/^\s+$/.test(p)) { frag.appendChild(document.createTextNode(p)); return; }
            var sp = document.createElement('span');
            sp.className = 'oxw'; sp.textContent = p;
            frag.appendChild(sp); words.push(sp);
          });
          n.replaceChild(frag, c);
        } else if (c.nodeType === 1) { walk(c); }
      });
    })(el);
    if (!words.length) return null;

    var lines = [], grp = null, prevTop = null;
    words.forEach(function (w) {
      var t = Math.round(w.offsetTop);
      if (prevTop === null || Math.abs(t - prevTop) > 3) { grp = []; lines.push(grp); prevTop = t; }
      grp.push(w);
    });
    if (lines.length > 8) return null;

    var out = [];
    lines.forEach(function (group) {
      var firstW = group[0], lastW = group[group.length - 1];
      var outer = document.createElement('span'); outer.className = 'oxl';
      var inner = document.createElement('span'); inner.className = 'oxli';
      firstW.parentNode.insertBefore(outer, firstW);
      var n = firstW, stop = lastW.nextSibling;
      while (n && n !== stop) { var nx = n.nextSibling; inner.appendChild(n); n = nx; }
      outer.appendChild(inner);
      out.push(inner);
    });
    el.dataset.oxln = '1';
    return out;
  };

  var headingSel = '.ox .hh, .ox .ptt, .ox .phero h1, .ox .sv h3, .ox .tail p, .ox .au h3, .ox .st h3';

  if (!reduce) {
    document.querySelectorAll(headingSel).forEach(function (el) {
      if (!splittable(el)) return;
      var lines = splitToLines(el);
      if (!lines || !lines.length) return;
      lines.forEach(track);
      gsap.set(lines, { yPercent: 112 });
      onView(el, function () {
        gsap.to(lines, { yPercent: 0, duration: 1.05, ease: E, stagger: 0.075, onComplete: function () { untrack(lines); } });
      });
    });

    /* ---- the statement line: words arrive one after another ---- */
    document.querySelectorAll('.ox .stmt').forEach(function (st) {
      var ws = [].slice.call(st.querySelectorAll('.wd'));
      if (!ws.length) return;
      ws.forEach(track);
      gsap.set(ws, { opacity: 0.12, y: 12 });
      onView(st, function () {
        gsap.to(ws, { opacity: 1, y: 0, duration: 0.7, ease: E, stagger: 0.026, onComplete: function () { untrack(ws); } });
      });
    });

    /* ---- the hero's hand-built line masks ---- */
    var heroLines = [].slice.call(document.querySelectorAll('.ox .hero .ln > span'));
    if (heroLines.length) {
      heroLines.forEach(track);
      gsap.set(heroLines, { yPercent: 112 });
      gsap.to(heroLines, { yPercent: 0, duration: 1.15, ease: E, stagger: 0.08, delay: 0.12, onComplete: function () { untrack(heroLines); } });
    }

    /* ---- images wipe up behind their own frame ---- */
    document.querySelectorAll('.ox .msk').forEach(function (m) {
      var im = m.querySelector('img, video');
      track(m);
      gsap.set(m, { clipPath: 'inset(0% 0% 100% 0%)' });
      if (im) gsap.set(im, { scale: 1.12, transformOrigin: 'center center' });
      onView(m, function () {
        var tl = gsap.timeline({ onComplete: function () { untrack(m); } });
        tl.to(m, { clipPath: 'inset(0% 0% 0% 0%)', duration: 1.1, ease: E });
        if (im) tl.to(im, { scale: 1, duration: 1.5, ease: E }, 0);
      });
    });

    /* ---- everything else rises a little ---- */
    var fades = [].slice.call(document.querySelectorAll('.ox .fu')).filter(function (e) { return !e.closest('.hero'); });
    fades.forEach(function (el) { track(el); });
    gsap.set(fades, { opacity: 0, y: 20 });

    document.querySelectorAll('.ox .rv').forEach(function (block) {
      var group = [].slice.call(block.querySelectorAll('.fu')).filter(function (e) { return !e.closest('.hero'); });
      if (!group.length) return;
      onView(block, function () {
        gsap.to(group, { opacity: 1, y: 0, duration: 0.8, ease: E, stagger: 0.06, onComplete: function () { untrack(group); } });
      });
    });
    fades.forEach(function (el) {
      if (el.closest('.rv')) return;
      onView(el, function () {
        gsap.to(el, { opacity: 1, y: 0, duration: 0.8, ease: E, onComplete: function () { untrack(el); } });
      });
    });

    /* ---- hero copy ---- */
    var heroBits = [].slice.call(document.querySelectorAll('.ox .hero .eyebrow, .ox .hero .sub, .ox .hero .cta, .ox .hero .cue'));
    if (heroBits.length) {
      heroBits.forEach(track);
      gsap.set(heroBits, { opacity: 0, y: 14 });
      gsap.to(heroBits, { opacity: 1, y: 0, duration: 0.75, ease: E, stagger: 0.07, delay: 0.35, onComplete: function () { untrack(heroBits); } });
    }

    /* ---- rules draw from the left (never hides anything) ---- */
    document.querySelectorAll('.ox .rule').forEach(function (r) {
      gsap.set(r, { scaleX: 0, transformOrigin: 'left center' });
      onView(r, function () { gsap.to(r, { scaleX: 1, duration: 1, ease: E }); });
    });
  } else {
    document.querySelectorAll('.ox .hero .ln > span').forEach(function (el) { el.style.transform = 'none'; });
  }

  /* ---- counters: only ever counts a number that is already on the page ---- */
  document.querySelectorAll('.ox [data-count]').forEach(function (el) {
    var target = parseFloat(el.getAttribute('data-count'));
    if (isNaN(target)) return;
    var suffix = el.getAttribute('data-suffix') || '';
    var prefix = el.getAttribute('data-prefix') || '';
    var dec = (el.getAttribute('data-count').split('.')[1] || '').length;
    if (reduce) { el.textContent = prefix + target.toFixed(dec) + suffix; return; }
    var o = { v: 0 };
    el.textContent = prefix + (0).toFixed(dec) + suffix;
    onView(el, function () {
      gsap.to(o, {
        v: target, duration: 1.6, ease: 'power2.out',
        onUpdate: function () { el.textContent = prefix + o.v.toFixed(dec) + suffix; }
      });
    });
  });

  /* ---- keep positions honest as fonts, images and video settle ---- */
  var refresh = function () { ScrollTrigger.refresh(); };
  window.addEventListener('load', refresh);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(refresh);
  var rt = null;
  window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(refresh, 220); });
})();